import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {Error1Component} from '@modules/pages/error-pages/error-1/error-1.component';
import {Error2Component} from '@modules/pages/error-pages/error-2/error-2.component';
export const ROUTES = {
  PREFIX: 'page',
  404: 'error-404',
  403: 'error-403',
  500: 'error-500',
  MAINTENANCE: 'error-maintenance'
};
const routes: Routes = [
  {
    path: ROUTES['404'],
    component: Error1Component,
    data: {
      code: 404
    }
  },
  {
    path: ROUTES['403'],
    component: Error1Component,
    data: {
      code: 403
    }
  },
  {
    path: ROUTES['500'],
    component: Error1Component,
    data: {
      code: 500
    }
  },
  {
    path: ROUTES.MAINTENANCE,
    component: Error2Component,
  },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PageRoutingModule { }
